import type { QueryClient, QueryKey } from '@tanstack/react-query';

/** `QUERY_KEYS.THREAD_MESSAGES(...)`: `['agent', 'threads', mode, company, id, 'messages']`. */
export function isThreadHistoryKey(key: readonly unknown[]): boolean {
  return key[0] === 'agent' && key[1] === 'threads' && key[5] === 'messages';
}

/**
 * After an approval decision. Cached histories not on screen are dropped, so
 * the next open loads them fresh: `useThreadMessages` does not refetch on
 * mount, and the copy it would reuse still offers the decided card. The thread
 * list and the history on screen refetch in place; the open chat keeps its
 * messages, because its runtime reads history only once.
 */
export function refreshThreadHistories(queryClient: QueryClient) {
  queryClient.removeQueries({
    predicate: (query) => isThreadHistoryKey(query.queryKey) && !query.isActive(),
  });
  void queryClient.invalidateQueries({ queryKey: ['agent', 'threads'] });
}

/**
 * One thread's history changed (a voice turn was saved). Same rule for that
 * history alone: dropped while nothing shows it, so the chat loads it fresh
 * however the user gets back there, refetched in place if something does.
 */
export function refreshThreadHistory(queryClient: QueryClient, queryKey: QueryKey) {
  queryClient.removeQueries({ queryKey, predicate: (query) => !query.isActive() });
  void queryClient.invalidateQueries({ queryKey });
}
